import React, { ReactElement } from 'react';
import { PageContent } from './page-content';
import { APP_CFG } from '../appcfg';
import { PageType, FixedOptionData, PageDataParams } from 'its-pages';
import { FixedOption } from '../containers/fixed-option';

export class FixedOptionContent extends PageContent {
  public get component(): ReactElement {
    return <FixedOption fixedOptionContent={this} key={this.pageData.seed} />;
  }

  public get pageType(): PageType {
    return PageType.Problem;
  }

  private logAnswers(): void {
    if (APP_CFG.log) {
      const pageData = this.pageData as FixedOptionData;

      APP_CFG.consoleLog(`${pageData.answer} is correct response`);
    }
  }
  public constructor(params: PageDataParams) {
    super(new FixedOptionData(params));
    this.logAnswers();
  }
}
